import { Fragment } from "react";
import { PopupHeader, PopupContent } from "../../../popup/common";
import FilingSummaryContent from "../../../filings/FilingSummaryContent";

function CpaCheckFiling({
  filingItem,
  acceptFilingHandler,
  checkFilingHandler,
}) {
  // Wrapper to handle PopupHeader calling with boolean instead of event
  const handleClose = () => {
    // Create a synthetic event-like object or call without event
    if (checkFilingHandler) {
      checkFilingHandler({ preventDefault: () => {} });
    }
  };

  return (
    <Fragment>
      <PopupHeader 
        title="Filing Summary" 
        setOpenState={handleClose}
        icon={`${process.env.PUBLIC_URL}/images/icons/filing_blue.svg`}
        variant="compact"
      />
      <PopupContent>
        <FilingSummaryContent 
          filing={filingItem} 
          showPrice={true}
          priceLabel="Price"
          priceValue={filingItem.amount_paid_cpa || "0.00"}
        />

        <div style={{ display: "flex", gap: "12px", justifyContent: "center", marginTop: "20px" }}>
          <button className="cta-button primary" onClick={acceptFilingHandler}>
            Accept
          </button>
          <button className="cta-button secondary" onClick={checkFilingHandler}>
            Close
          </button>
        </div>
      </PopupContent>
    </Fragment>
  );
}

export default CpaCheckFiling;
